/**
 * components/landing/ai-platform/sections/Automation.jsx — §4.7.
 * Six-tile grid of AI-assisted workflows.
 */

import React from 'react'
import {
  Rocket, GraduationCap, LineChart, Headphones, Cog, BellRing, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { AUTOMATION } from '../data'
import { TONE } from '../_shared'

const ICONS = { Rocket, GraduationCap, LineChart, Headphones, Cog, BellRing }

export default function Automation() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Workflow Automation</Eyebrow>
          <SectionHeading
            align="center"
            title={<>AI that <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">does the boring work.</span></>}
            subtitle="Every automation is opt-in, guarded, and reversible. Humans stay in the loop for high-consequence actions; low-consequence work runs quietly in the background."
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {AUTOMATION.map((a) => {
            const tone = TONE[a.tone] || TONE.orange
            const Icon = ICONS[a.iconKey] || Sparkles
            return (
              <div key={a.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl overflow-hidden hover:border-white/20 hover:bg-white/[0.03] hover:-translate-y-[1px] transition-all">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex flex-col gap-3">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 18, height: 18 }} />
                  </span>
                  <div>
                    <h4 className="text-base font-semibold text-white leading-tight">{a.label}</h4>
                    <p className="text-sm text-zinc-400 leading-relaxed mt-1">{a.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
